const data = 
      [{
        id: 5,
        title: 'Introduction to MI',
        text: 'A short introduction to MI.',
        video: "/static/cdn/9convert.com_-_Mobility_Intel_Inc_Profile_1080p_ydkez1.mp4",
        thumb: "/static/cdn/Untitled_lu2f57.jpg"
      },
      {
        id: 1,
        title: 'MI Equal Opportunity',
        text: 'MI is an Equal Opportunity Employer and we want to give everyone the chance they deserve.',
        video: "/static/cdn/mob%C4%B1l%C4%B1ty_x264_urf3i3.mp4",
        thumb: "/static/cdn/mob%C4%B1l%C4%B1ty_pae32c.jpg"
      }, {
        id: 2,
        title: 'MI\'s Leadership Development',
        text: 'Everyone at MI has the capacity to be a leader.',
        video: "/static/cdn/growing_with_mobility_x264_pqaqub.mp4",
        thumb: "/static/cdn/growing_with_mobility_tmywlo.jpg"
      },
      {
        id: 3,
        title: 'MI Supporting Our Youth',
        text:  'See how MI supports and helps our youth succeed.',
        video: "/static/cdn/4._Mobility_Intel_Supporting_Our_Youth_x264_wtwedh.mp4",
        thumb: "/static/cdn/bg5_pd1zkc.png"
      }, {
        id: 4,
        title: '5G Network',
        text: 'The 5G Network is here and it\'s here to stay.',
        video: "/static/cdn/5g_x264_rretl5.mp4",
        thumb: "/static/cdn/5g_aeyrz4.png"
      },
    ];

export default data;


// WEBPACK FOOTER //
// ./src/assets/data/videosData.js